import { gql } from '@apollo/client';

const GET_SAFETY_REPORT = gql`
query inspectionSafetyReport($regionId: Int!, $claimIndx: Int!, $attachToClaim: Boolean, $frenchVersion: Boolean,  $userGuid: UUID, $phaseIndx: Int, $sendToSymbility: Boolean) {
  inspectionSafetyReport(regionId: $regionId, claimIndx: $claimIndx, attachToClaim: $attachToClaim, frenchVersion: $frenchVersion, userGuid: $userGuid, phaseIndx: $phaseIndx, sendToSymbility: $sendToSymbility)
}`;

export default GET_SAFETY_REPORT;